import { useRef } from 'react'

export function useCache<T = any>(expireInSecs: number) {
  const caches = useRef<T[]>([])

  const getItem = (condition: (item: T) => boolean) => {
    const _data = [...caches.current]
    const i = _data.findIndex(condition)
    if (i === -1) return undefined
    const now = new Date().getTime()
    if ((_data[i] as any).expiredAt <= now) {
      _data.splice(i, 1)
      caches.current = _data
      return undefined
    }
    return _data[i]
  }

  const setItem = (data: T, condition: (item: T) => boolean) => {
    const i = caches.current.findIndex(condition)
    if (i === -1)
      caches.current.push({
        ...data,
        expiredAt: new Date().getTime() + expireInSecs * 1000,
      })
    else
      caches.current[i] = {
        ...data,
        expiredAt: new Date().getTime() + expireInSecs * 1000,
      }
  }

  const deleteItem = (condition: (item: T) => boolean) => {
    const _data = [...caches.current]
    const i = _data.findIndex(condition)
    if (i === -1) return
    _data.splice(i, 1)
    caches.current = _data
  }

  const deleteAll = () => {
    caches.current = []
  }

  return {
    caches,
    getItem,
    setItem,
    deleteItem,
    deleteAll,
  }
}

export default useCache
